import { Chip, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { fCoins } from "src/utils/formatNumber";
import { fDateTime } from "src/utils/formatTime";

export default function VoucherTable({ vouchers }) {
	return (
		<TableContainer component={Paper}>
			<Table sx={{ minWidth: 750 }} aria-label="voucher table">
				<TableHead>
					<TableRow>
						<TableCell>ID</TableCell>
						<TableCell>Code</TableCell>
						<TableCell>Amount</TableCell>
						<TableCell>User</TableCell>
						<TableCell>Game ID</TableCell>
						<TableCell>Status</TableCell>
						<TableCell>Created At</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{vouchers?.map((voucher) => (
						<TableRow key={voucher.voucher_id}>
							<TableCell>{voucher.voucher_id}</TableCell>
							<TableCell>{voucher.code}</TableCell>
							<TableCell>{fCoins(voucher.amount)}</TableCell>
							<TableCell>
								{voucher.user_id ? <a href={`/dashboard/profile?user_id=${voucher.user_id}`}>{voucher.user_id}</a> : "—"}
							</TableCell>
							<TableCell>{voucher.game_id ?? "—"}</TableCell>
							<TableCell>
								<Chip label={voucher.status === 0 ? "UNUSED" : "USED"} color={voucher.status === 0 ? "error" : "success"} size="small" />
							</TableCell>
							<TableCell>{fDateTime(new Date(voucher.created_at))}</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
}
